
    import '/home/ec2-user/Youlify-Design/components/alert/index.$tab-design.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["components-alert-index-tab-design-demo-behavior-pattern","components-alert-index-tab-design-demo-content","components-alert-index-tab-design-demo-type","components-alert-index-tab-design-demo-action"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/home/ec2-user/Youlify-Design/components/alert/index.$tab-design.zh-CN.md?type=demo')
};